import { useTranslation } from 'next-i18next'
import useUser from 'shared/hooks/use-user'
import { determineTimezone } from 'shared/utils/date-time/determine-timezone'
import {
  formatActivityRelativeDate,
  formatPublicationRelativeDate,
} from 'shared/utils/date-time/format-community-relative-date'

type DateInput = Date | number | string

const toDate = (date: DateInput): Date => (date instanceof Date ? date : new Date(date))

export const usePublicationRelativeDate = (date: DateInput | null | undefined): string => {
  const { t } = useTranslation()
  const { user } = useUser()

  if (date == null) {
    return ''
  }

  return formatPublicationRelativeDate(toDate(date), {
    locale: user?.dashboardLocale,
    timeZone: determineTimezone(user),
    translate: t,
  })
}

export const useActivityRelativeDate = (date: DateInput | null | undefined): string => {
  const { user } = useUser()

  if (date == null) {
    return ''
  }

  return formatActivityRelativeDate(toDate(date), {
    locale: user?.dashboardLocale,
    timeZone: determineTimezone(user),
  })
}
